import { useSearchParams } from 'react-router-dom'

import type { SORT_BY } from '@eshop/type'
import { useQuery } from '@tanstack/react-query'

import mock, { type ProductSeason } from '#/global/mock/productSeasonList'

import { AddToCartSeason } from '#/global/component/Product/AddToCart/Season'
import { LayoutGrid } from '#/global/component/Product/LayoutGrid'
import { PriceSeason } from '#/global/component/Product/Price/Season'
import { ProductPreviewLong } from '#/global/component/Product/ProductPreviewLong'

import { Config } from '#/global/helper/Config'

export const Season = () => {
    const lang = Config.getLang()
    const [searchParameters, setSearchParameters] = useSearchParams()

    const query = searchParameters.get('query')
    const page = Number(searchParameters.get('page')) || 1

    const products = useQuery({
        queryKey: ['season', { page, query }],
        queryFn: async () => fetchSeasonList({ query, page }),
        // placeholderData: previousData => previousData ?? ({ list: Array.from({ length: 12 }), itemsCount: 0 }),
    })

    const handleSetPage = (page: number) => {
        const urlParameters = new URLSearchParams(window.location.search)
        urlParameters.set('page', page.toString())
        setSearchParameters(urlParameters)
    }

    const handleSortBy = (sortBy: SORT_BY) => {
        const urlParameters = new URLSearchParams(window.location.search)
        urlParameters.set('sortBy', sortBy.toString())
        setSearchParameters(urlParameters)
    }

    return (
        <LayoutGrid
            lang={lang}
            loadingState={!products.isSuccess}
            page={page}
            productsCount={products.data?.itemsCount ?? 0}
            setPage={handleSetPage}
            setSortBy={handleSortBy}
            sortBy="DEFAULT">
            {products.data?.list.map((product, index) => (
                product
                    ? (
                            <ProductPreviewLong
                                key={product.code}
                                AddToCart={<AddToCartSeason lang={lang} unit={product.unit} />}
                                loadingState={!products.isSuccess}
                                product={product}
                                ProductPrice={(
                                    <PriceSeason
                                        availability={{ state: product.availabilityStatus, value: product.availability }}
                                        info="cena za ks"
                                        price={product.price}
                                        unit={product.unit}
                                    />
                                )}
                            />
                        )
                    : <ProductPreviewLong key={index} loadingState />
            ))}
        </LayoutGrid>
    )
}

interface FetchProps { page: number, query: string | null }
// @ts-expect-error mock
const fetchSeasonList = async ({ _page, _query }: FetchProps): Promise<{ itemsCount: number, list: (ProductSeason | null)[] }> => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve({
                list: mock,
                itemsCount: mock.length,
            })
        }, 2000)
    })
}
